import React from 'react'

export const ADDRESS_FIELDS_CONFIG = ({ formState, onChange, intl }) => ({
  CP_MUNICIPIO: {
    value: formState['cp_municipio'],
    name: 'cp_municipio',
    optionKey: 'municipio',
    title: intl.formatMessage({
      id: 'pages.inspections.addAddressForm.fields.cp_municipio.label',
    }),
    placeholder: intl.formatMessage({
      id: 'pages.inspections.addAddressForm.fields.cp_municipio.placeholder',
    }),
    required: true,
    renderOption: (option) => {
      const cp = option['cp'] || ''
      const municipio = option['municipio'] || ''
      if (!cp && !municipio) return ''
      if (!cp) return municipio
      if (!municipio) return cp
      return `${cp} - ${municipio}`
    },
    requestTimeout: 600,
    onChange,
  },
  DIRECCION: {
    value: formState['direccion'],
    name: 'direccion',
    optionKey: 'nombreVia',
    title: intl.formatMessage({
      id: 'pages.inspections.addAddressForm.fields.direccion.label',
    }),
    placeholder: intl.formatMessage({
      id: 'pages.inspections.addAddressForm.fields.direccion.placeholder',
    }),
    renderOption: (option) => [option['tipo_via'], option['calle']].filter(Boolean).join(' '),
    required: true,
    disabled: !formState['cp_municipio'],
    inputMinLength: 1,
    requestTimeout: 600,
    onChange,
  },
  NUMERO: {
    value: formState['numero'],
    name: 'numero',
    optionKey: 'numero',
    title: intl.formatMessage({
      id: 'pages.inspections.addAddressForm.fields.numero.label',
    }),
    placeholder: intl.formatMessage({
      id: 'pages.inspections.addAddressForm.fields.numero.placeholder',
    }),
    renderOption: (option) => option['numero_finca'] || '',
    required: true,
    disabled: !formState['direccion'],
    onChange,
  },
  VIVIENDA: {
    value: formState['vivienda'],
    name: 'vivienda',
    optionKey: 'vivienda',
    title: 'Vivienda',
    renderOption: (option) => {
      if (option.special === 'other') {
        return 'No encuentro mi dirección'
      }

      const label = (
        (option['portal'] ? `Portal ${option['portal']} ` : '') +
        (option['bloque'] ? `Bloque ${option['bloque']} ` : '') +
        (option['escalera'] ? `Escalera ${option['escalera']} ` : '') +
        (option['piso'] ? `Piso ${option['piso']} ` : '') +
        (option['puerta'] ? `Puerta ${option['puerta']} ` : '')
      ).trim()

      return label
    },
    placeholder: 'Portal, Escalera, Piso, Puerta',
    required: true,
    disabled: !formState['numero'],
    onChange,
  },
  // DERIVATION: {
  //   value: formState['derivation'],
  //   name: 'derivation',
  //   optionKey: 'derivation',
  //   title: intl.formatMessage({
  //     id: 'pages.inspections.addAddressForm.fields.derivation.label',
  //   }),
  //   placeholder: intl.formatMessage({
  //     id: 'pages.inspections.addAddressForm.fields.derivation.placeholder',
  //   }),
  //   required: true,
  //   multiple: true,
  //   disabled: !formState['numero'],
  //   onChange,
  // },
  DERIVATION: {
    multiple: true,
    value: formState['derivation'] || [],
    name: 'derivation',
    optionKey: 'derivation',
    title: intl.formatMessage({
      id: 'pages.inspections.addAddressForm.fields.derivation.label',
    }),
    placeholder: intl.formatMessage({
      id: 'pages.inspections.addAddressForm.fields.derivation.placeholder',
    }),

    renderOption: (option) => {
      if (typeof option !== 'object' || option === null) {
        return ''
      }
      const portal = option['portal'] ? `Portal: ${option['portal']} ` : ''
      const escalera = option['escalera'] ? `Escalera: ${option['escalera']} ` : ''
      const count_cups = option['count_cups'] ? `Nº CUPS: ${option['count_cups']} ` : ''
      const cod_derivacion = option['cod_derivacion'] ? `Código: ${option['cod_derivacion']}` : ''

      return `${portal}${escalera}${count_cups}${cod_derivacion}`.trim()
    },
    required: true,
    disabled: !formState['numero'],
    onChange,
  },
  CUPS_NUMBER: {
    readOnly: true,
    value: formState['cups_number'],
    name: 'cups_number',
    label: intl.formatMessage({
      id: 'pages.inspections.addAddressForm.fields.cups_number.label',
    }),
  },
})

export const ADDRESS_FORM_FIELDS = [
  'cp_municipio',
  'direccion',
  'numero',
  'derivation',
  'cups_number',
  'vivienda',
]
